import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import {
    MatPaginator, MatSort, MatTableDataSource,
    MatDialog, MatDialogRef
} from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/takeUntil';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../core/animations';

/** Local file */
import { spekWalk, toastMsg, toolTip, paginationForCustomTable, itemsPerPage } from '../../../../utils/index';

/**Pipe file */
import { FiveDigitRandomNumberPipe } from '../../../../pipesFiles/randomNumber.pipe';
// import { UTCsecondsPipe } from '../../../../pipesFiles/utcSeconds.pipe';

/**Query files */
import {
    WalkCallQueryService,
    ReportReviewQueryService,
    WCCategoriesQueryService,
    BookingsQueryService
} from '../../../../queryFiles/index';

/**Service files */
import { SolutionFormService } from '../../solutionForm.service';

/**Local component */
import { ToastComponent } from '../../../../common/toast.component';
import { AddSubCategoryPopupComponent } from './add-subcategory/addSubCategory.component';
import { FuseConfirmDialogComponent } from '../../../../../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'walk-call-body',
    templateUrl: './walkCallBody.component.html',
    styleUrls: ['./walkCallBody.component.scss'],
    animations: fuseAnimations,
    providers: [
        FiveDigitRandomNumberPipe,
        // UTCsecondsPipe
    ],
    encapsulation: ViewEncapsulation.None,
})

export class WalkCallBodyComponent {

    spekwoWalkValues = spekWalk;
    toolTip = toolTip;
    toastMsg = toastMsg;

    newAttribute: SummaryReport = <SummaryReport>{
        mainCategory: '',
        subCategory: '',
        summary: '',
        totalCost: '',
        itemNumber: '',
        subCategories: []
    };

    selectedCategory: any;

    currentOrderId: number;

    pageNumber: number;// for which page we are currently in
    dragIndex: number;// for identifying dragIndex based on paginator value
    lastReviewId: any;
    insReportId: string;

    page: number = 1;

    reviewSubscription = new Subject<void>();
    categorySubscription = new Subject<void>();

    enableApprovedSubscription: Subscription;
    insReportIdChangeSubscription: Subscription;
    wcChangesSubscription: Subscription;
    wcRRChangesSubscription: Subscription;
    wcRRCategoryChangesSubscription: Subscription;
    wcRRCreateChangesSubscription: Subscription;
    wcRRInsCheckSubscription: Subscription;
    wcRRCreateSubscription: Subscription;

    public unsubscribe = new Subject<void>();

    enableSave: boolean = false;
    bodySpinner: boolean = false;
    categorySpinner: boolean = false;
    enableSubmit: boolean = true;
    enableApproved: boolean = true;
    categoryError: boolean = false;

    todayDate: Date;
    reviewDate: Date;

    checkBoxCategories: any = []; //List available categories - Display purpose - final array
    existingCategories = []; //Assigned stroed value from backedn

    selectedCategories: Categories[] = [];
    currentSelectedCategories: Categories[] = []; //Currently added categories


    subCategories: any = [];
    allSubCategories: subCategories[] = [];
    fieldArray = [];
    cost = [];

    allReviewReports: SummaryReport[] = [];
    allReviewReports1: SummaryReport[] = []; //Temp array for reassigning

    beforeTotalCost: number = 0; // total cost before saving

    displayedColumns = ['category', 'subCategory', 'summary', 'itemNumber', 'cost'];
    // Pagination 
    pagination = paginationForCustomTable;
    itemsPerPage: number = itemsPerPage; //Items per page in paginator

    summaryDataSource: MatTableDataSource<SummaryReport>;


    @ViewChild(MatPaginator) summaryPaginator: MatPaginator;
    @ViewChild(MatSort) summarySort: MatSort;

    selectedIndex: number = -1; //To find drag index to highlight row

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    constructor(
        private route: ActivatedRoute,
        public dialog: MatDialog,

        /** Local component */
        public toastComponent: ToastComponent,

        /**Pipe files */
        private pipe: FiveDigitRandomNumberPipe,

        /**Query files */
        private reportReviewQueryService: ReportReviewQueryService,
        private walkCallQueryService: WalkCallQueryService,
        private wCCategoriesQueryService: WCCategoriesQueryService,
        private bookingsQueryService: BookingsQueryService,

        /** Service files */
        private solutionFormService: SolutionFormService
    ) {
        this.todayDate = new Date();
        this.reviewDate = new Date();

    }

    ngOnInit() {

        this.beforeTotalCost = 0; // total cost before saving
        this.cost = [];
        this.pageNumber = 1;// initially set to 1st page
        this.dragIndex = 0;// initially set to 0

        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = Number.parseInt(params.id);
        });

        // get reportId from service file
        this.insReportIdChangeSubscription = this.solutionFormService.insReportIdChange.subscribe(data => {
            this.insReportId = data && data.insReportId;
        })

        // get isApproveChange from service file
        this.enableApprovedSubscription =
            this.solutionFormService.isApproveChange.subscribe(data => {

                this.enableApproved = data == 'yes' ? false : true;

                // To scroll to top 
                this.scrollToTop();

            })

        // get previous selected categories from query file
        this.getWalkCallDetails();
    }

    ngOnDestroy() {
        this.reviewSubscription && this.reviewSubscription.unsubscribe();
        this.categorySubscription && this.categorySubscription.unsubscribe();

        this.insReportIdChangeSubscription && this.insReportIdChangeSubscription.unsubscribe();
        this.enableApprovedSubscription && this.enableApprovedSubscription.unsubscribe();//bec of when update element - its shows error, hide this
        this.wcChangesSubscription && this.wcChangesSubscription.unsubscribe();
        this.wcRRChangesSubscription && this.wcRRChangesSubscription.unsubscribe();
        this.wcRRCategoryChangesSubscription && this.wcRRCategoryChangesSubscription.unsubscribe();
        this.wcRRCreateChangesSubscription && this.wcRRCreateChangesSubscription.unsubscribe();
    }

    // get previous selected categories from query file
    getWalkCallDetails() {

        this.bodySpinner = true;

        this.wcChangesSubscription = this.walkCallQueryService.GET_Walk_Call_DETAILS(this.currentOrderId)
            .valueChanges
            .subscribe((walkCallResponse: any) => {

                var matchObject: any = {};
                this.existingCategories = [];

                if (walkCallResponse &&
                    walkCallResponse.data &&
                    walkCallResponse.data.allWalkCalls.nodes.length > 0
                ) {
                    this.existingCategories = [];
                    /**Get Categories */
                    _.each(walkCallResponse.data.allWalkCalls.nodes, (details, key) => {

                        matchObject = _.find(this.spekwoWalkValues.categoriesList, { 'key': details.category });

                        this.existingCategories.push({
                            key: details.category,
                            category: matchObject != undefined ? matchObject.value : '',
                            id: details.id,
                            value: this.spekwoWalkValues.categoryDisplayValue[details.category],
                            checked: true,
                            callDate: details.callDate
                        })

                        if (walkCallResponse.data.allWalkCalls.nodes.length == key + 1) {
                            //    Avoid duplicates if exist
                            _.uniqBy(this.existingCategories, 'category');

                            this.getReportReviewDetails();
                        }
                    })
                } else {
                    this.existingCategories = [];
                    this.getReportReviewDetails();
                }
            })
    }

    /**Check report submitted for this order */
    getReportReviewDetails() {
        this.bodySpinner = true;

        var reportReview = this.reportReviewQueryService
            .GET_All_STORED_REPORTS(this.currentOrderId);

        this.wcRRChangesSubscription = reportReview
            .takeUntil(this.reviewSubscription)
            .subscribe((response: any) => {

                this.allReviewReports = [];
                this.allReviewReports1 = [];

                if (response &&
                    response.data &&
                    response.data.allReportReviewDetails &&
                    response.data.allReportReviewDetails.edges.length > 0) {

                    var edges = response.data.allReportReviewDetails.edges;

                    this.solutionFormService.isApproveChange.next(edges[0].node.approve); //set enable approve here

                    edges.forEach((review, key) => {

                        this.allReviewReports.push({
                            mainCategory: review.node.categoryName,
                            subCategory: review.node.subCategoryName,
                            name: review.node.subCategoryName ? review.node.categoryName + ':' + review.node.subCategoryName : review.node.categoryName,
                            summary: review.node.solution,
                            totalCost: review.node.totalCost,
                            itemNumber: review.node.itemNumWc,
                            subCategories: [],
                            reviewId: review.node.reviewId,
                            id: review.node.id,
                            approve: review.node.approve,
                            nodeId: review.node.nodeId,
                            insReportId: review.node.insReportId,
                            imagePath: review.node.imagePath,
                            description: review.node.description,
                            solSubCategory: review.node.solSubCategory,
                            solCategory: review.node.solCategory
                        });

                        //Temp array for reassigning
                        this.allReviewReports1.push({
                            mainCategory: review.node.categoryName,
                            subCategory: review.node.subCategoryName,
                            name: review.node.subCategoryName ? review.node.categoryName + ':' + review.node.subCategoryName : review.node.categoryName,
                            summary: review.node.solution,
                            totalCost: review.node.totalCost,
                            itemNumber: review.node.itemNumWc,
                            subCategories: [],
                            reviewId: review.node.reviewId,
                            id: review.node.id,
                            approve: review.node.approve,
                            nodeId: review.node.nodeId,
                            insReportId: review.node.insReportId,
                            imagePath: review.node.imagePath,
                            description: review.node.description,
                            solSubCategory: review.node.solSubCategory,
                            solCategory: review.node.solCategory
                        });

                        if (response.data.allReportReviewDetails.edges.length == this.allReviewReports.length) {

                            this.reviewSubscription.complete(); /**Complete subscription */

                        }

                    })

                } else {
                    this.refreshData();
                    this.solutionFormService.isApproveChange.next('no'); //set enable approve here
                }

            }, () => {
                this.bodySpinner = false;
            }, () => {
                this.bodySpinner = false;
                this.refreshData();
            })
    }
    //once row deleted call from child component
    refreshAllReviewReports() {
        // To scroll to top 
        this.scrollToTop();
        this.getReportReviewDetails();
    }

    refreshData() {
        this.getWcCategoriesWithSubCate();
    }

    // after delte all rows
    refreshDataAfterDeleteAll() {
        // get previous selected categories from query file
        this.getWalkCallDetails();
    }

    /**Get WC Categories */
    getWcCategoriesWithSubCate() {

        this.categorySpinner = true;
        this.wcRRCategoryChangesSubscription = this.wCCategoriesQueryService.GET_WC_CATEGORIES()
            .valueChanges
            .takeUntil(this.categorySubscription)
            .subscribe((response: any) => {

                this.checkBoxCategories = [];
                this.selectedCategories = [];
                var matchObject: any = {};
                this.subCategories = [];
                this.allSubCategories = [];

                if (response &&
                    response.data &&
                    response.data.allWccategories &&
                    response.data.allWccategories.nodes.length > 0
                ) {
                    _.each(response.data.allWccategories.nodes, (categories, index) => {

                        //Check  if subcategory non empty
                        if (categories.wcSubCategoriesByCategoryId) {

                            _.each(categories.wcSubCategoriesByCategoryId.nodes, subCategory => {

                                this.allSubCategories.push({
                                    subCategory: subCategory.subCategory,
                                    subId: subCategory.subid,
                                    categoryId: subCategory.categoryId
                                })
                            })
                        }
                        // Check category already checked
                        matchObject = _.find(this.existingCategories, { 'key': categories.category });

                        // Checked category stored with row or not
                        var matchQuery = _.find(this.allReviewReports, { mainCategory: categories.category });

                        var objectAssign = {

                            key: categories.category,
                            value: this.spekwoWalkValues.categoryDisplayValue[categories.category],
                            checked: matchObject != undefined ? true : false,
                            catgoryId: categories.categoryId,
                            disabled: matchQuery != undefined ? true : false // for disabling the categories if it is already saved

                        }
                        this.checkBoxCategories.push(objectAssign);

                        if ((index + 1) == response.data.allWccategories.nodes.length) {
                            this.categorySubscription.complete();
                            this.categorySpinner = false;
                        }
                        //Check category not checked
                        if (matchObject != undefined) {
                            this.selectedCategories.push(objectAssign);
                        }

                    })
                }
            }, () => {
                this.categorySpinner = false;
            })
    }


    /**Date change function */
    onDateChange(value) {
        // console.log('value', value);
        // this.reviewDate = value.value.toDateString();

    }

    /**Select checkbox value */
    chooseCategory(selected: any, index) {

        if (selected.checked) {
            var matchObject = _.find(this.selectedCategories, { 'key': selected.value }); //find selected value not yet stored
            if (matchObject === undefined) { //if yes
                this.selectedCategories.push(selected); //for remove from  backend
                this.currentSelectedCategories.push(selected); //for add new to to  backend
            }
        }
        else {
            var matchQuery = _.find(this.allReviewReports, { mainCategory: selected.value });//before removing check it is previously saved or not
            if (matchQuery == undefined) {
                _.remove(this.selectedCategories, ['key', selected.value]) //for remove from  backend
                _.remove(this.currentSelectedCategories, ['key', selected.value]) //for add new to to  backend
            }
        }
    }

    /**Based on dropdown selct on category populate sub categories if exist  */
    dropdownCategory(selected) {
        this.subCategories = this.allSubCategories;
        this.selectedCategory = selected;

        this.subCategories = _.filter(this.subCategories, { 'categoryId': selected.catgoryId });
    }

    /**Enable save button once select category */
    getInputValue(value) {

        this.enableSave = value ? true : false;
        this.enableSaveonCheck(); //Checking if category and itemNumber field is empty or not

    }

    //Checking if category and itemNumber field is empty or not
    enableSaveonCheck() {

        var tempEnableSave = true;

        this.fieldArray.forEach(data => {
            if ((!data.mainCategory || !data.itemNumber) && (data.subCategory || data.summary || data.totalCost)) {
                this.enableSave = false;
                tempEnableSave = false;
            }

        })

        if (tempEnableSave == true) {
            this.enableSave = true;
        }
    }

    /** Add new  subcategory value */
    addSubCategory(index, mainCategory) {

        this.openPopup(index, mainCategory)

    }
    //finding current index
    findIndex(index) {
        return (index = (Number(this.itemsPerPage) * (Number(this.pageNumber) - 1)) + Number(index))
    }
    /**open popup for adding sub catgeory */
    openPopup(index, mainCategory) {

        if (this.selectedCategory) {

            const dialogRef = this.dialog.open(AddSubCategoryPopupComponent, {
                width: '400px',
                data: {
                    mainCategoryId: this.selectedCategory.catgoryId
                }
            });

            dialogRef.afterClosed().subscribe(result => {

                if (!result) {
                    return;
                }

                const actionType: string = result[0];
                const returnData: subCategories = result[1];
                switch (actionType) {
                    /**
                     * Save
                     */
                    case 'save':

                        this.toastComponent.showToast(toastMsg.addSubCategory);
                        /*Once add refresh sub categories**/
                        this.subCategories.push(returnData);
                        this.allSubCategories.push(returnData);
                        this.resetDropdownList(index, mainCategory);
                        break;
                    /**
                    * Failed
                    */
                    case 'failed':
                        this.toastComponent.showToast(toastMsg.failedReview);
                        break;

                    case 'cancel':
                        break;

                }

            });

        } else {
            this.toastComponent.showToast(toastMsg.warningForAddSubCate);
        }

    }

    resetDropdownList(index, mainCategory) {
        if (this.fieldArray.length > 0) {
            this.setSubCategories2(index, mainCategory);
        }
    }

    /** Use same ngmodel value used for all rows in datasource */

    setSubCategories(mainCatgeory) {
        this.subCategories = this.allSubCategories;
        if (mainCatgeory && this.selectedCategory) {
            if (mainCatgeory == this.selectedCategory.key) {
                this.subCategories = _.filter(this.subCategories, { 'categoryId': this.selectedCategory.catgoryId });
            } else {
                var matchQuery = _.find(this.checkBoxCategories, { 'key': mainCatgeory });
                if (matchQuery) {
                    this.subCategories = _.filter(this.subCategories, { 'categoryId': matchQuery.catgoryId });
                }

            }
        }
    }

    setSubCategories2(index, mainCategory) {

        if (mainCategory) {
            index = this.findIndex(index);
            this.fieldArray[index].subCategories = this.allSubCategories;
            var matchQuery = _.find(this.checkBoxCategories, { 'key': mainCategory });
            if (matchQuery) {
                this.fieldArray[index].subCategories = _.filter(this.fieldArray[index].subCategories, { 'categoryId': matchQuery.catgoryId });
            }

        }
        this.refreshDatasource(this.fieldArray);
    }

    /** Add new rows */
    addNew(type) {
        // for add single row
        if (type == 'onSave') {
            if (this.fieldArray.length == 0) {
                this.fieldArray.push(this.newAttribute); /** first add previously typed */
                this.fieldArray = this.fieldArray.concat({});/** Add new row */
            }
            else {
                this.fieldArray.push(this.newAttribute);
            }
        }
        // for add multiple rows
        else {
            this.fieldArray.push(this.newAttribute); /** first add previously typed */
            for (var i = 0; i < 10; i++) {
                this.fieldArray = this.fieldArray.concat({});/** Add new row */
            }
        }

        this.refreshDatasource(this.fieldArray);

        /*Empty previous typed value*/
        this.initializeObject();

    }

    // Remove row functionality
    removeEntry(removeRow, removeIndex) {

        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteCategoryConfirm;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

        this.confirmDialogRef.afterClosed().subscribe(result => {

            if (result) {

                this.fieldArray = _.pull(this.fieldArray, removeRow);

                //after removing row calculating total cost
                this.selectedCost('');

                this.enableSave = this.fieldArray.length == 0 ? false : true;

            }
            this.confirmDialogRef = null;
        });


    }
    initialDrag(id) { //dragstart -before Review reoprts
        this.selectedIndex = id;
    }
    // changindex on drag
    changeIndexOnDrag(i) {
        this.selectedIndex = i;
    }
    // Once drop refresh index
    onDropDataSuccess() {
        this.selectedIndex = -1;
    }
    // set current paginator value
    getPaginator(key) {
        this.itemsPerPage = key;
        this.dragIndexChange();
    }
    //set current page
    getPage($event) {
        this.pageNumber = $event;
        this.dragIndexChange();
    }
    // for identifying dragIndex based on paginator value
    dragIndexChange() {
        this.dragIndex = (Number(this.itemsPerPage) * (Number(this.pageNumber) - 1))
    }
    //to calculate totalcost
    selectedCost(value) {
        this.beforeTotalCost = 0;
        // if field array is empty - single row
        if (this.fieldArray.length == 0) {
            if (value) {
                this.beforeTotalCost = value;
            }
        }
        // if field array > 0
        else {
            var flag = 0;
            if (flag == 0) {
                flag = 1;
                this.fieldArray.forEach(data => {
                    if (data.totalCost) {
                        this.beforeTotalCost = Number(this.beforeTotalCost) + Number(data.totalCost);
                    }
                })
            }
        }
    }

    /** Submit values */
    submit() {

        this.bodySpinner = true;

        /**Store categories & walk date */
        if (this.selectedCategories.length > 0) {

            /**Values in new attrbute initially */
            if (this.newAttribute.mainCategory ||
                this.newAttribute.subCategory ||
                this.newAttribute.summary ||
                this.newAttribute.totalCost) {

                // Check item number typed or not if field array length is 0
                if (this.newAttribute.itemNumber) {
                    this.fieldArray.push(this.newAttribute);
                    this.initializeObject();
                } else {
                    this.bodySpinner = false;
                    this.toastComponent.showToast(toastMsg.warningForitemNumber);
                }

            }

            /**Find empty object in array */
            this.fieldArray = _.filter(this.fieldArray, function (value) {
                return (!_.isEmpty(value.subCategory) ||
                    !_.isEmpty(value.mainCategory) ||
                    !_.isEmpty(value.itemNumber) ||
                    !_.isEmpty(value.summary));
            });

            this.enableSubmit = this.fieldArray.length == 0 ? false : this.enableSubmit;

            /** Find empty item number in each row */
            this.fieldArray.forEach(element => {
                if (!element.itemNumber || !element.mainCategory) {
                    this.enableSubmit = false;
                    this.categoryError = !element.mainCategory ? true : false;
                }
            })

            if (this.enableSubmit == true) {

                var randomId = this.pipe.generateNumber();

                //deleting - the unchecked checkbox in db,if it is not saved previously.
                this.existingCategories.forEach(data => {
                    var findValue = _.find(this.selectedCategories, { value: data.value });
                    if (findValue == undefined) {
                        this.walkCallQueryService.DELETE_WALK_CALL(data);
                    }
                })

                /**Get unique code */
                //currently selected categories - adding it to db.
                if (this.currentSelectedCategories.length > 0) {

                    this.selectedCategories = this.currentSelectedCategories;

                    _.each(this.selectedCategories, (list, key) => {

                        this.wcRRCreateChangesSubscription =
                            this.walkCallQueryService.CREATE_WALK_CALL_MUTATION(this.currentOrderId, list.key, this.reviewDate)
                                .takeUntil(this.reviewSubscription)
                                .subscribe(() => {

                                    if ((key + 1) == this.selectedCategories.length) {
                                        this.commonQueryFunction(randomId);
                                    }

                                }, () => {
                                    this.failedMsg();
                                })

                    })
                }
                //if we didn't select any new categories.
                else {
                    this.commonQueryFunction(randomId);
                }
            } else {
                this.bodySpinner = false;
                this.enableSubmit = true;
                if (this.categoryError === true) {
                    this.toastComponent.showToast(toastMsg.warningForCategory);
                    this.categoryError = false;
                }
                else {
                    this.toastComponent.showToast(toastMsg.warningForitemNumber);
                }
            }

        } else {
            this.bodySpinner = false;
            this.toastComponent.showToast(toastMsg.warningBeforeReview);

        }
    }

    commonQueryFunction(randomId) {

        if (!this.insReportId) {
            this.solutionFormService.CreateInspectionReport(this.currentOrderId, randomId)
                .then(() => {

                    this.bookingsQueryService.UPDATE_SCHEDULE_BOOKING_BY_ORDERID(randomId, this.currentOrderId)
                    //Get already report generated with id      
                    this.storeFinalSolution(randomId, this.fieldArray);

                })
                .catch(() => {
                    this.failedMsg();
                })
        } else {
            this.storeFinalSolution(this.insReportId, this.fieldArray);

        }
    }
    async storeFinalSolution(insReportId, fieldArray) {

        /**Get last review id */

        this.solutionFormService.getLastReviewId()
            .then((response: any) => {
                this.lastReviewId = Number.parseInt(response);
                fieldArray.forEach(async (allElement, key) => {

                    // this.lastReviewId = this.UTCsecondsPipe.transform();

                    this.lastReviewId = this.lastReviewId + 1;

                    //Manully enters all itmes ,not in pdf document
                    this.solutionFormService.CreateSolutionMaster(this.currentOrderId,
                        this.lastReviewId, insReportId,
                        allElement.mainCategory, allElement.subCategory, allElement, null)
                        .then(() => {


                            if ((key + 1) == fieldArray.length) {
                                this.toastComponent.showToast(toastMsg.afterReview);
                                this.beforeTotalCost = 0;
                                this.solutionFormService.insReportIdOfOrder(this.currentOrderId);
                                this.bodySpinner = false;
                                this.enableSave = false;
                                this.fieldArray = [];
                                this.lastReviewId = this.lastReviewId;
                                this.selectedCategories = [];
                                this.currentSelectedCategories = [];
                                this.initializeObject();
                                this.ngOnInit();
                            }
                        })
                        .catch(() => {
                            this.failedMsg();
                        })

                });
            })
            .catch(() => {
                this.lastReviewId = 0;
                this.failedMsg();
            })

    }

    /**Initialize object  */
    initializeObject() {

        this.newAttribute = <SummaryReport>{
            mainCategory: '',
            subCategory: '',
            summary: '',
            totalCost: '',
            itemNumber: '',
            subCategories: []
        };

    }

    /**Refresh data source object  */
    refreshDatasource(fieldArray) {

        this.summaryDataSource = new MatTableDataSource(fieldArray);
        this.summaryDataSource.paginator = this.summaryPaginator;
        this.summaryDataSource.sort = this.summarySort;

    }

    /**Failed block */
    failedMsg() {
        this.bodySpinner = false;
        this.toastComponent.showToast(toastMsg.failedReview);
    }

    // To scroll to top 
    scrollToTop() {
        const contentContainer = document.getElementById('walk-call-body');
        contentContainer.scrollIntoView();
    }
}

export interface Categories {
    key: string;
    value: string;
    checked: boolean;
    catgoryId: number;
    disabled: boolean
}
export interface SummaryReport {
    mainCategory: string;
    subCategory: string;
    summary: string;
    totalCost: any;
    itemNumber: string;
    subCategories: any;
    reviewId: string;
    id: number;
    approve: string;
    nodeId: string;
    insReportId: string;
    name: string;
    imagePath: string;
    description: string;
    solSubCategory: string;
    solCategory: String;
}
export interface subCategories {
    categoryId: number,
    subCategory: string,
    subId: number
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/walkCallBody.component.ts